import { tDocumentStatus } from 'common/modules/ReactShared/data/api/document/types';
import { IChatMessage, tPersonInfo } from './types';

export function getInitialsFromName(name: string): string {
  if (!name) return '';
  const splitted = name.split(' ');
  if (splitted.length >= 2) {
    const [first, second] = splitted;
    return (first[0] + second[0]).toUpperCase();
  }
  let result: string;
  if (name.length >= 2) {
    result = name[0] + name[1];
  } else {
    result = name.toUpperCase();
  }

  return result;
}

export function getPersonInfo(person: {
  avatarURL: string | null;
  name: string;
  initials?: string | null;
}): tPersonInfo {
  return {
    avatar: person.avatarURL,
    name: person.name,
    initials: person.initials ?? getInitialsFromName(person.name)
  };
}

export function canStudentAddNewAnswer(
  assignmentInfo: {
    status: tDocumentStatus;
  } | null
): boolean {
  return assignmentInfo?.status === 'rejected' || false;
}

export function getLastStudentMessage(messages?: IChatMessage[]): IChatMessage | null {
  return (
    (messages
      ? [...messages].reverse().find((message) => message.from === 'outgoing')
      : null) || null
  );
}

export function getLastMessage(messages?: IChatMessage[]): IChatMessage | null {
  return messages?.length ? messages[messages.length - 1] : null;
}
